<!--
 * @Descripttion: your project
 * @version: 1.0
 * @Author: zouyuping
 * @Date: 2023-06-02 17:42:53
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-07-03 11:12:40
-->
<template>
  <div class="richtext">
    <div
      :style="{
        background: datas.backColor,
        'padding-top': datas.paddingTop + 'px',
        'padding-bottom': datas.paddingBottom + 'px',
        'padding-left': datas.paddingLeft + 'px',
        'padding-right': datas.paddingRight + 'px',
        'border-style': datas.borderStyle,
        'border-color': datas.borderColor,
        'border-width': datas.borderLineWeight + 'px',
        'border-radius': datas.borderRadius + 'px',
        'margin-top': datas.marginTop + 'px',
        'margin-bottom': datas.marginBottom + 'px',
        'margin-left': datas.marginLeft + 'px',
        'margin-right': datas.marginRight + 'px',
      }"
      @click="handleClickName"
    >
      <div class="ql-container ql-snow">
        <div class="ql-editor" v-html="datas.myValue" />
      </div>
    </div>
  </div>
</template>

<script>
import { handleScanCode } from "@/utils";

export default {
  name: "Richtext",
  props: {
    datas: Object,
  },
  methods: {
    handleClickName() {
      if (this.datas.linkType == "scanCode") {
        // 调起微信扫码，扫码取号并自动跳转到扫码信息页面
        handleScanCode();
      } else if (this.datas.linkUrl) {
        window.location.href = this.datas.linkUrl;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.richtext {
  position: relative;
  ::v-deep img {
    max-width: 100% !important;
    display: block;
  }
}
</style>
